import React from 'react';
import './CalendlyButton.css';

function CalendlyButton() {
  const handleClick = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/philippstaufenberger/60min'
      });
    }
    return false;
  };

  return (
    <div className="calendly-button-container">
      <button
        className="calendly-inline-button"
        onClick={handleClick}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
          <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" strokeWidth="2"/>
          <circle cx="8" cy="14" r="1" fill="currentColor"/>
          <circle cx="12" cy="14" r="1" fill="currentColor"/>
          <circle cx="16" cy="14" r="1" fill="currentColor"/>
          <circle cx="8" cy="18" r="1" fill="currentColor"/>
          <circle cx="12" cy="18" r="1" fill="currentColor"/>
        </svg>
        <span>Termin vereinbaren (60 Min)</span>
      </button>
    </div>
  );
}

export default CalendlyButton;
